module.exports = __webpack_public_path__ + "img/banner-1.2d84c876.jpg";